import { useMutation } from "@tanstack/react-query";
import { ShipDataType } from "@/types/apiTypes";
import { removeShipFromProjectApi } from "@/API/removeShipFromProjectApi";
import { useInvalidateQueries } from "@/hooks/helperHooks/useInvalidateQueries";
import { ShowNotification } from "@/components/ShowNotification";
import { notifications } from "@mantine/notifications";
type RemoveShipParams = {
  ship: ShipDataType;
  projectId: string;
};
export const useRemoveShipFromProject = () => {
  const { invalidateShips, invalidateShip, invalidateProjects } =
    useInvalidateQueries();
  return useMutation<void, Error, RemoveShipParams>({
    mutationFn: async ({ ship, projectId }) => {
      return removeShipFromProjectApi(ship, projectId);
    },
    onError: (error: any) => {
      ShowNotification({
        title: "Error",
        message: "An error occurred while removing the ship.",
        color: "error",
      });
      throw new Error(error.message);
    },
    onSuccess: (_data, variables) => {
      notifications.show({
        title: "Ship removed from project",
        message: `${variables.ship.ship_name} has been removed from the project.`,
        color: "success",
        position: "top-center",
      });
      invalidateShips();
      invalidateShip(variables.ship.id);
      invalidateProjects(); // todo : Maybe here we need another type of invalidation
    },
  });
};
